import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { useAuthBridge } from "../lib/auth";
import { LinkButton } from "./Button";
import { Container } from "./Container";

export function AuthConfigurationNotice() {
  return (
    <Container className="py-24">
      <div className="mx-auto max-w-2xl rounded-brand border border-brand-line bg-white p-8 text-center shadow-soft">
        <LockKeyhole className="mx-auto text-brand-accent" size={34} aria-hidden="true" />
        <h1 className="mt-5 text-3xl font-black text-brand-text">Auth Error:</h1>
        <p className="mt-4 text-brand-text/64">
          PUBLIC KEYS NOT FOUND
        </p>
      </div>
    </Container>
  );
}

export function ProtectedRoute({ children, role }: { children: ReactNode; role?: "admin" }) {
  const auth = useAuthBridge();
  const location = useLocation();

  if (!auth.isLoaded) {
    return (
      <Container className="py-24">
        <div className="rounded-brand border border-brand-line bg-white p-8 text-center shadow-soft">
          <p className="font-bold text-brand-text/70">Loading secure workspace...</p>
        </div>
      </Container>
    );
  }

  if (!auth.isSignedIn) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (role === "admin" && auth.role !== "admin") {
    return (
      <Container className="py-24">
        <div className="rounded-brand border border-brand-line bg-white p-8 text-center shadow-soft">
          <h1 className="text-3xl font-black text-brand-text">Admin access required.</h1>
          <p className="mt-3 text-brand-text/64">Your account is signed in, but it does not have the admin role.</p>
        </div>
      </Container>
    );
  }

  return children;
}
